import { useAppStore } from '@/stores/app'

export const isAuthenticated = (): boolean => {
  const appStore = useAppStore()
  return appStore.isLoggedIn()
}

export const isAdmin = (): boolean => {
  const appStore = useAppStore()
  return !!appStore.identity?.is_admin
}

// Initial codes every operator/administrator starts with — a new code may never equal one of these.
export const INITIAL_PINS = ['1234', '0000']

export const isValidNewPin = (pin: string, currentPin = ''): boolean =>
  /^\d{4}$/.test(pin) && !INITIAL_PINS.includes(pin) && pin !== currentPin
